export default __webpack_public_path__ + "static/media/man-1.e0de84ec.jpg";